import PropTypes from 'prop-types';
import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides';
import { ensureArray, safeMap, safeGetProp, ensureString } from 'utils/safeArray';
import { ImageZoom } from 'components/ImageZoom';

export default function DesignMockup({ title, panels, accent_color }) {
  const safePanels = ensureArray(panels);
  
  return (
    <FrameWithStickyTitle title={title} accentColor={accent_color}>
      <div className="grid h-full min-h-0 w-full gap-4 p-4 md:grid-cols-3">
        {safeMap(safePanels, (panel, idx) => {
          const panelTitle = ensureString(safeGetProp(panel, 'title'), `Panel ${idx + 1}`);
          const imageUrl = ensureString(safeGetProp(panel, 'image_url'), '');
          const content = ensureString(safeGetProp(panel, 'content'), '');
          
          return (
            <div key={idx} className="flex min-w-0 flex-col text-center rounded-lg border-t-4 bg-white p-4 shadow-md" style={{ borderColor: accent_color || '#cc0000' }}>
              <h4 className="text-md font-semibold text-slate-800 mb-3">{panelTitle}</h4>
              <div className="mb-3 flex justify-center">
                <div className="relative flex h-48 w-full max-w-xs items-center justify-center overflow-hidden rounded-md bg-slate-100">
                  {imageUrl ? (
                    <ImageZoom src={imageUrl} alt={panelTitle} />
                  ) : (
                    <div className="text-center p-4">
                      <div className="text-4xl mb-2">📱</div>
                      <div className="text-sm text-slate-600 font-medium">{panelTitle}</div>
                      <div className="text-xs text-slate-500 mt-1">Mockup Preview</div>
                    </div>
                  )}
                </div>
              </div>
              {content ? (
                <p className="text-sm text-slate-600 text-left leading-snug">{content}</p>
              ) : null}
            </div>
          );
        })}
      </div>
    </FrameWithStickyTitle>
  );
}

DesignMockup.propTypes = {
  title: PropTypes.string,
  panels: PropTypes.array,
  accent_color: PropTypes.string,
};
